import React, { useMemo } from 'react';
import { useToggle } from 'react-use';

import { useAllDatasetFields, useDatasets } from '../../../shared/api/apiHooks';
import { CategoriesModal } from '../Categories/CategoriesModal';
import { DatasetsFilterDefaultValues, DatasetsFiltersTransformers } from '../DatasetFilters/datasetFilterConfig';
import { DatasetFilters } from '../DatasetFilters/DatasetFilters';
import { DatasetsListTable } from '../DatasetsListTable/DatasetsListTable';
import { allFieldsFiltersTransformers, allFieldsListDefaultValues } from '../FieldFilters/fieldFilterConfig';
import { FieldFilters } from '../FieldFilters/FieldFilters';
import { useFilterPaginagion } from '../Filters/auxiliaryFields';
import { useFormDataCategoryField } from '../Filters/FilterFields/CategoryField';
import { useFilterForm } from '../Filters/useFilterForm';
import { CommonDataFieldsSelector, getDefaultCommonDataFilterValues } from '../CommonDataFieldsSelector/CommonDataFieldsSelector';
import { AllFieldsListTable } from '../AllFieldsListTable/AllFieldsListTable';
import { useWatch } from 'react-hook-form';
import { filterFields } from '../Filters/FilterFields/dataExplorerFieldsConfig';
import { useSelector } from 'react-redux';
import { hasConsultantOrResearcherPermission } from '../../../reducers/AuthenticationReducer/AuthenticationSelector';

export function DatasetsTab() {
  const defaultValues = useMemo(() => ({ ...DatasetsFilterDefaultValues, ...getDefaultCommonDataFilterValues() }), []);

  const { control, reset, debouncedQueryObject } = useFilterForm({
    fieldTransformers: DatasetsFiltersTransformers,
    defaultValues: defaultValues,
  });

  const datasets = useDatasets({ queryObject: debouncedQueryObject });

  const filterPagination = useFilterPaginagion({ control, defaultValues });

  const [categoriesOpened, toggleCategoriesOpen] = useToggle(false);
  const { selectedCategory, onCategoryClick } = useFormDataCategoryField(control);
  const isPyramidMultiplierVisible = useSelector(hasConsultantOrResearcherPermission);
  const isSearchActive = (useWatch({ name: filterFields.search.name, control }) || '').trim() !== '';

  return (
    <>
      <DatasetFilters
        isExtraFilterChanged={false}
        selectedCategory={selectedCategory}
        onCategoryModalOpen={() => {
          toggleCategoriesOpen();
        }}
        control={control}
        reset={reset}
      />

      <div>
        {categoriesOpened && (
          <CategoriesModal
            selectedCategory={selectedCategory}
            onCategoryClick={onCategoryClick}
            onClose={() => toggleCategoriesOpen(false)}
            control={control}
          />
        )}
      </div>

      <DatasetsListTable
        isSearchActive={isSearchActive}
        filterPagination={filterPagination}
        control={control}
        datasetQueryResult={datasets}
        isPyramidMultiplierVisible={isPyramidMultiplierVisible}
      />
      <CommonDataFieldsSelector className={'data-common-fields--search'} control={control} />
    </>
  );
}

export function FieldsTab() {
  const defaultValues = { ...allFieldsListDefaultValues, ...getDefaultCommonDataFilterValues() };

  const { control, reset, debouncedQueryObject } = useFilterForm({
    fieldTransformers: allFieldsFiltersTransformers,
    defaultValues: defaultValues,
  });

  const isPyramidMultiplierVisible = useSelector(hasConsultantOrResearcherPermission);
  const filterPagination = useFilterPaginagion({ control, defaultValues });
  const fieldsResult = useAllDatasetFields({ queryObject: debouncedQueryObject });
  const isSearchActive = (useWatch({ name: filterFields.search.name, control }) || '').trim() !== '';

  return (
    <>
      <FieldFilters isExtraFilterChanged={false} control={control} reset={reset} />
      <AllFieldsListTable
        isSearchActive={isSearchActive}
        filterPagination={filterPagination}
        control={control}
        result={fieldsResult}
        isPyramidMultiplierVisible={isPyramidMultiplierVisible}
      />

      <CommonDataFieldsSelector className={'data-common-fields--search'} control={control} />
    </>
  );
}
